import { useContext } from 'react';

import { WagmiConnectStateContext } from '../contexts/wagmi-connect-state';

export const useWagmiConnect = () => {
  return useContext(WagmiConnectStateContext);
};
